import styled, { css } from 'styled-components';
import { getToken } from '@optimus-web/common';
import { Container } from '../Container';

export interface BackdropProps {
    light?: boolean;
}

export const Backdrop = styled(Container).attrs({ 'data-test-backdrop': true })<BackdropProps>`
    position: absolute;
    inset: 0;
    background-color: ${getToken('backgroundBackdrop')};

    ${(props) =>
        props.light &&
        css`
            opacity: 0.4;
            background-color: ${getToken('backgroundStaticSunken')};
        `}
`;
